module.exports = __webpack_public_path__ + "static/img/9.fb1f5f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/sp/9.png
// module id = lMtq
// module chunks = 0